(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glytch-slideshow"] && !Shopify.designMode) return;
  try {
    
  function initHeroSlider(sectionContainer) {
    const sliderInner = sectionContainer.querySelector('.hero-slider-inner');
    const slides = sectionContainer.querySelectorAll('.hero-slide');
    const bullets = sectionContainer.querySelectorAll('.bullet');
    if (!sliderInner || slides.length <= 1) return;

    let isDragging = false,
        startPos = 0,
        currentTranslate = 0,
        prevTranslate = 0,
        animationID = 0,
        currentIndex = 0;

    const intervalTime = 5000;
    let slideInterval;

    function setSliderPosition() {
      sliderInner.style.transform = `translateX(${currentTranslate}px)`;
    }

    function updateBullets(index) {
      bullets.forEach(b => b.classList.remove('active'));
      if(bullets[index]) bullets[index].classList.add('active');
    }

    function showSlide(index) {
      currentIndex = index;
      currentTranslate = currentIndex * -sectionContainer.offsetWidth;
      prevTranslate = currentTranslate;
      sliderInner.style.transition = 'transform 0.5s ease-out';
      setSliderPosition();
      updateBullets(currentIndex);
    }

    bullets.forEach((bullet, index) => {
      bullet.addEventListener('click', () => {
        stopSlider();
        showSlide(index);
        startSlider();
      });
    });

    function nextSlide() {
      currentIndex = (currentIndex + 1) % slides.length;
      showSlide(currentIndex);
    }

    function startSlider() {
      stopSlider();
      slideInterval = setInterval(nextSlide, intervalTime);
    }

    function stopSlider() {
      clearInterval(slideInterval);
    }

    sliderInner.addEventListener('mousedown', dragStart);
    sliderInner.addEventListener('touchstart', dragStart);
    sliderInner.addEventListener('mouseup', dragEnd);
    sliderInner.addEventListener('touchend', dragEnd);
    sliderInner.addEventListener('mousemove', dragMove);
    sliderInner.addEventListener('touchmove', dragMove);
    sliderInner.addEventListener('mouseleave', dragEnd);

    function dragStart(event) {
      stopSlider();
      isDragging = true;
      startPos = getPositionX(event);
      sliderInner.style.transition = 'none';
      animationID = requestAnimationFrame(animation);
      sliderInner.style.cursor = 'grabbing';
    }

    function dragMove(event) {
      if (isDragging) {
        const currentPosition = getPositionX(event);
        let diff = currentPosition - startPos;
        if (currentIndex === 0 && diff > 0) diff = 0;
        if (currentIndex === slides.length - 1 && diff < 0) diff = 0;
        currentTranslate = prevTranslate + diff;
      }
    }

    function dragEnd() {
      isDragging = false;
      cancelAnimationFrame(animationID);
      sliderInner.style.cursor = 'grab';
      const movedBy = currentTranslate - prevTranslate;
      if (movedBy < -100 && currentIndex < slides.length - 1) currentIndex += 1;
      if (movedBy > 100 && currentIndex > 0) currentIndex -= 1;
      showSlide(currentIndex);
      startSlider();
    }

    function getPositionX(event) {
      return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
    }

    function animation() {
      setSliderPosition();
      if (isDragging) requestAnimationFrame(animation);
    }

    window.addEventListener('resize', () => showSlide(currentIndex));
    startSlider();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.hero-slider').forEach((s) => initHeroSlider(s));
  });

  document.addEventListener('shopify:section:load', (event) => {
    const slider = event.target.querySelector('.hero-slider');
    if (slider) initHeroSlider(slider);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
